import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/ocean-technology/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function AutonomousSurveillance() {
  const products = [
    
    "Oceanographic Data Management and Mapping Software",
    

  ];
  const data = {
    image: "/industries/ocean-technology/oceanographic-data-management-and-mapping-software.jpg", // Replace with the appropriate image URL
    intro: `Navigate the complexities of oceanographic data with our advanced management and mapping software. Unlock the full potential of your data for insightful decision-making and comprehensive mapping.`,
    keyFeatures: [
      {
        title: "Data Organization and Cataloging",
        content: "Efficiently organize and catalog oceanographic data, ensuring easy access and management.",
      },
      {
        title: "High-Resolution Mapping",
        content: "Create high-resolution maps to visualize oceanographic features and phenomena with precision.",
      },
      {
        title: "Collaborative Data Sharing",
        content: "Facilitate collaborative data sharing, promoting teamwork and collective insights.",
      },
    ],
    howItWorks: `Explore the seamless integration of data management and mapping. Learn how our software transforms raw oceanographic data into actionable insights and visually stunning maps.`,
    benefits: {
      title: "The benefits of Oceanographic Data Management and Mapping Software",
      data: [
        "Streamlined Data Access",
        "Enhanced Visualization",
        "Improved Collaboration",
      ],
    },
    industries: "Tailored for oceanographers, research institutions, and environmental agencies. Discover how our software addresses the unique needs of various industries.",
    stories: `Read about successful projects empowered by our data management and mapping software. See how organizations have leveraged our technology for groundbreaking discoveries.`,
    contactUs: `Connect with our experts to discuss your specific requirements. Whether you are conducting oceanographic research or managing environmental data, we have the solutions for you.`,
    futureDevelopments: `Stay informed about upcoming features and innovations in data management and mapping technology. Witness the evolution of tools that redefine oceanographic research.`,
    technology: `Learn about the compatibility of our software with other tools and systems. See how our solution seamlessly integrates into your existing workflow.`,
    support: `Access comprehensive training resources and ongoing support. Ensure that your team is well-equipped to leverage the full potential of our oceanographic data management and mapping software.`,
    industry: `Understand our commitment to industry standards and compliance. Rest assured that your data is handled with the utmost integrity and security.`,
    events: "Stay updated on relevant events and collaborative opportunities in the field of oceanography. Join us in shaping the future of oceanographic research.",
    blog: `Explore our blog and knowledge hub for articles, case studies, and expert insights on oceanographic data management and mapping.`,
    careers: `Discover exciting career opportunities in the field of oceanography and software development. Join us in advancing the frontiers of oceanographic research and technology.`,
  };
  


  
  
  const content = "Embark on an oceanic technology voyage with us! Whether you're navigating advancements in marine technology, underwater exploration, environmental monitoring, or any facet of ocean technology, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our ocean technology solutions align seamlessly with your objectives, budget, and scope."
    return (
    <>
 <Head>
    <title>Oceanographic Data Management and Mapping Software | Manage Ocean Data | Techbrain Networks</title>
    <meta name="description" content="Efficiently manage and map oceanographic data with Techbrain Networks software, designed for researchers and marine scientists." />
    <meta name="keywords" content="oceanographic data management, ocean mapping software, marine data systems, Techbrain Networks" />
    <meta property="og:title" content="Oceanographic Data Management and Mapping Software | Manage Ocean Data | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Oceanographic Data Management and Mapping Software allows seamless integration and visualization of ocean data for research." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Oceanographic Data Management and Mapping Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Oceanographic Data Management and Mapping Software | Manage Ocean Data" />
    <meta name="twitter:description" content="Techbrain Networks Oceanographic Data Management and Mapping Software efficiently manages and maps oceanographic data for researchers." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Oceanographic Data Management and Mapping Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Techbrain Networks Oceanographic Data Management and Mapping Software provides efficient tools for managing and visualizing oceanographic data.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
                     <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#ED8D8D"} />

      <AppbarIndustry title={"Ocean and Technology"} homeLink={'/industries/ocean-technology'} link={'/industries/ocean-technology/products'} />
      <HeroSection img={"/industries/ocean-technology/oceanographic-data-management-and-mapping-software.jpg"}>Oceanographic Data Management and Mapping Software

</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#080707",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
         {/* Key Features Unleashed */}
         <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#ED8D8D",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#ED8D8D"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
       {/* Industries */}
       <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

          

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in autonomous surveillance and reconnaissance technology
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

           

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#ED8D8D",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
        <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#ED8D8D"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#ED8D8D"} bg={"#080707"} />
    </>
  );
}

export default AutonomousSurveillance;
